import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  itemsWrapper: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },

  itemsWrapper: {
    gap: 16,
    width: '100%',
  },
});

export default styles;
